import { DashIdCardComponent } from '../dash-id-card/dash-id-card.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { LastPaymentComponent } from '../last-payment/last-payment.component';
import { AffinityNoticeComponent } from '../../notices/affinity-notice/affinity-notice.component';
import { BnErrorNoticeComponent } from '../../billing-new/bn-notice/bn-error-notice/bn-error-notice.component';
import { BnImpNoticeComponent } from '../../billing-new/bn-notice/bn-imp-notice/bn-imp-notice.component';
import { RenewalNoticeComponent } from '../../notices/renewal-notice/renewal-notice.component';
import { BnUpcomingPaymentNoticeComponent } from '../../billing-new/bn-notice/bn-upcoming-payment-notice/bn-upcoming-payment-notice.component';
import { PolicyCardHeaderComponent } from '../myinsurance-headers/policy-card-header/policy-card-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { PolicyRenewalComponent } from '../myinsurance-policy-renewal/myinsurance-policy-renewal.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { SystemMaintenanceComponent } from '../../../../screens/system-maintenance/system-maintenance.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';
import * as _ from 'underscore';
import { FlagResponse } from '@models/flag-response';
import { SortByStatusPipe } from '../../../../../_helpers/_pipes/sort-by-status.pipe';
import { TitleCaseHyphenatedNamePipe } from '../../../../../_helpers/_pipes/titlecase-hyphenated-name.pipe';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { PaymentServiceService } from '../../../../../_services/payment-service/payment-service.service';
import { PolicyDetailsService } from './../../../../../_services/my-insurance/policy-details.service';
import { FlagDataService } from './../../../../../_services/data-services/flag-data.service';
import { PaperlessService } from './../../../../../_services/_iam/paperless.service';
import { CustomerBannerService } from './../../../../../_services/banner/customer-banner/customer-banner.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Constants } from '@models/constants';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyTypeService } from '@services/_iam/company-type.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataLayerService } from '@services/data-layer/data-layer.service';
import { ClientCredentialsService } from '@services/client-credentials/client-credentials.service';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { InfoTooltipComponent } from '../../../../common/info-tooltip/info-tooltip.component';
import { AddMissingPolicyComponent } from '../../../../common/add-missing-policy/add-missing-policy.component';
import { PolicyCardMinAmountDueComponent } from './policy-card-min-amount-due/policy-card-min-amount-due.component';
import { DisclaimersComponent } from '../../../../common/disclaimers/disclaimers.component';
import { LoyaltyBannerComponent } from './../../../../../loyalty-banner/loyalty-banner.component';

@Component({
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, FormsModule, DisclaimersComponent, LoyaltyBannerComponent, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, SystemMaintenanceComponent, MapfreLoadingComponent, PolicyRenewalComponent, MapfreCardComponent, PolicyCardHeaderComponent, BnUpcomingPaymentNoticeComponent, RenewalNoticeComponent, BnImpNoticeComponent, BnErrorNoticeComponent, AffinityNoticeComponent, LastPaymentComponent, MapfreButtonComponent, DashIdCardComponent, SortByStatusPipe, TitleCaseHyphenatedNamePipe,PolicyCardMinAmountDueComponent, AddMissingPolicyComponent],
  selector: 'app-my-insurance-main',
  templateUrl: './my-insurance-main.component.html',
  styleUrls: ['./my-insurance-main.component.scss'],
  providers: [SortByStatusPipe, TitleCaseHyphenatedNamePipe],
})
export class MyInsuranceMainComponent implements OnInit {
  @Input() policy: any;
  hideOrShow = false;
  payNowModal: ModalOptions;
  policyResponse: any;
  loading: boolean;
  hideModalOnRoute: any = false;
  accordianWithMDB: any = {};
  activePolicyArray: any = [];
  inactivePolicyArray: any = [];
  allPolicies: any = [];
  expiringPolicyArray: any;
  expiringLivoPolicyList: any = [];
  showBillingMessage: boolean;
  currentMinAmtDue: any;
  outstandingBalance: any;
  priorTermBalance: any;
  expandCurrentBalances: boolean;
  paymentDate: any;
  isPaperless: boolean;
  isAutoPay: boolean;
  isPaymentus: boolean;
  isACH: boolean;
  payBill: boolean;
  showMessage: boolean;
  isCCDC: boolean;
  isAcmic: boolean;
  isEligibleForPopup = false;
  eligiblePolicies: string[] = [];
  loginCount: string;
  isNativeApp: boolean;
  showOpenBayOnRunDate: boolean;
  showValidateCustModal = false;
  policyTypesList: string[] = [];
  isCustomerBannerServiceInvoked = false;
  expandedClass = "fa-chevron-up";

  paymentForm: FormGroup;
  policyCheckDigits: string;
  payBillLink: any;
  source: any;
  showLoyaltyBanner = false;
  policies: any;
  outBalanceTooltipContentMap: { [policyNumber: string]: string } = {};

  constructor(
    private policyDataService: PolicyDataService,
    private alertService: AlertService,
    private paymentService: PaymentServiceService,
    private policyDetailsService: PolicyDetailsService,
    private flagDataService: FlagDataService,
    private paperlessService: PaperlessService,
    private acmicService: AcmicService,
    private customerBannerService: CustomerBannerService,
    private deviceService: DeviceDetectorService,
    private companyTypeService: CompanyTypeService,
    private router: Router,
    private dataLayer: DataLayerService,
    private clientCredentialsService: ClientCredentialsService,
    private policyTooltipService: PolicyTooltipService
  ) {
    this.detectStateCode();
    this.payNowModal = new ModalOptions({
      additionalButtonClasses: 'basic primary x-small-btn pay-now-btn-sz',
      additionalClasses:
        'pay-now-modal modal-medium modal-dialog modal-center-on-page modal-dialog-scrollable',
      buttonCopy: 'PAY_NOW',
      modalId: 'payNow',
      modalTranslateCopy: `${this.isAcmic ? 'MODAL_MAKE_A_PAYMENT' : ''}`,
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'my-insurence_payNow',
    });

    this.accordianWithMDB = {
      one: false,
      two: false,
      three: false,
      four: false,
      five: false,
      six: false,
    };
  }

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent) {
    event.stopPropagation();
    tooltip.toggle();
  }

  closeNonActiveCollapse(name): void {    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

  showMore(): void {
    this.hideOrShow = !this.hideOrShow;
  }

  onPayByCardBilling(policyNumber, zipCode, minAmount) {
    this.paymentService.setPaymentData(policyNumber, zipCode, minAmount);
    this.hideModalOnRoute = true;
    if (policyNumber.length === 10) {
      this.paymentService.redirectToPaymentExpress(
        this.isNativeApp,
        this.isAcmic
      );
    } else {
      this.paymentService.redirectToPayBill(policyNumber, zipCode, minAmount);
    }
  }

  onCreatePaymentForm(accountID, zipCode, minAmount, format, company) {
    const minAmountDueonPolicy = Number(minAmount).toFixed(2);
    let xmlResp;
    if (company.companyName == 'TW') {
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else if (company.companyName == 'ACIC') {
      if (company.companyId == '25')
        xmlResp = company.companyId + 'B2C'
      else
        xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else {
      xmlResp = `<MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    }
    return xmlResp;
  }

  getPayBillLink(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).url
  }

  getPayBillSource(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).source
  }

  getAmountDue(minAmount) {
    return Number(minAmount).toFixed(2);
  }



  getCheckDigits(policyNumber, checkDigits, company, zipCode, format) {
    if (company == 'TW')
      return policyNumber + ';' + zipCode;
    else if (company == 'ACIC')
      return format.suffix + ';' + format.number
    else
      return policyNumber + checkDigits;
  }

  showToast() {
    this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
    window.scroll(0, 0);
  }

  payNow(policy) {
    const policyNumber = policy?.policynumber?.policyNumber;
    this.router.navigate(['/billing-new', policyNumber, 'make-a-payment']);
  }

  hideModal() {
    this.hideModalOnRoute = false;
  }

  triggerDatalayer(label: string) {
    const event = {
      name: 'click_link',
      category: 'remarked content',
      detail: 'manage policy',
      label: label
    }
    this.dataLayer.pushEvent(event);
  }
  preloadPaymentUsToken(policyNumber: string) {
    if (policyNumber.length === 10) {
      this.paymentService.preloadAndSaveToken(policyNumber);
    }
  }

  resetHideModal() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  onShowMessage() {
    this.showMessage = true;
    this.hideModalOnRoute = true;
  }

  closeModal() {
    this.showMessage = false;
  }

  public checkForPaperlessBanner(user): void {
    this.paperlessService.canRemindPaperless(user?.username).subscribe(
      (remind: boolean) => {
        this.paperlessService.togglePaperlessBanner(remind);
      },
      () => {
        this.paperlessService.togglePaperlessBanner(true);
      }
    );
  }
  private setPopupEligiblePolicies(policy): void {
    this.eligiblePolicies.push(policy.policynumber.policyNumber);
  }

  public isBannerOrPopupEligible(policyResponse): boolean {
    let isBannerOrPopupEligible = false;
    const isFirstimeLogin = JSON.parse(localStorage.getItem('isFirstimeLogin'));
    policyResponse.forEach((policy) => {
      if (policy.policyStatus === 'ACTIVE') {
        if (policy.eligibleForPopup) {
          this.isEligibleForPopup = true;
          this.setPopupEligiblePolicies(policy);
        }
        if (isFirstimeLogin) {
          this.isEligibleForPopup = true;
          this.setPopupEligiblePolicies(policy);
        }
        const policyFlags = policy.policyFlags;
        if (
          (policyFlags.isEdfEligible === 'Y' &&
            (policyFlags.isEdf === 'UNENROLLED' ||
              policyFlags.isEdf === 'FALSE')) ||
          (policyFlags.isEbillEligible === 'Y' &&
            (policyFlags.isEbill === 'UNENROLLED' ||
              policyFlags.isEbill === 'FALSE'))
        ) {
          isBannerOrPopupEligible = true;
        }
      }
    });
    this.paperlessService.updateEligiblePolicies(this.eligiblePolicies);
    return isBannerOrPopupEligible;
  }
  public checkPaperlessBannerAndPopup(policyResponse, isOpenBay = false): void {
    if (this.isBannerOrPopupEligible(policyResponse)) {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      if (!isOpenBay) {
        this.checkForPaperlessBanner(user);
      }
    }
  }
  makeListOfActivePolicyTypes(policyType) {
    if (!this.policyTypesList.includes(policyType)) {
      this.policyTypesList.push(policyType);
    }
  }


  public isEligibleForCustomerBanner(policyResponse): boolean {
    let showCusomerBannner = false;
    this.policyTypesList = [];
    policyResponse.forEach((policy) => {

      if (
        policy.policyStatus === 'ACTIVE' &&
        (policy.policyType === 'AUTO' || policy.policyType === 'HOME')
      ) {
        showCusomerBannner = true;
        this.makeListOfActivePolicyTypes(policy.policyType);
      }
    });
    return showCusomerBannner;
  }
  public getDeviceType() {
    let signedSource;
    if (!this.isNativeApp) {
      if (this.deviceService.isDesktop()) {
        signedSource = 'd';
      } else if (this.deviceService.isTablet()) {
        signedSource = 't';
      } else if (this.deviceService.isMobile()) {
        signedSource = 'm';
      } else {
        signedSource = '';
      }
    } else {
      signedSource = 'm';
    }
    return signedSource;
  }
  public checkCustomerBannerOrPaperlessEligibility(policyResponse): void {
    if (!this.isAcmic) {
      if (this.isEligibleForCustomerBanner(policyResponse)) {
        if (this.isCustomerBannerServiceInvoked) {
          return;
        }
        this.customerBannerService
          .getCustomerBannerDataFromAPI(
            this.policyTypesList,
            this.getDeviceType()
          )
          .subscribe(
            (customerBannerData) => {
              if (customerBannerData) {
                const criteria = customerBannerData.criteria;
                let lastDateOfRenewal;
                this.isCustomerBannerServiceInvoked = true;
                if (criteria.includes('RENEWAL')) {
                  lastDateOfRenewal = criteria.substring(
                    criteria.indexOf('=') + 1,
                    criteria.lastIndexOf('&')
                  );
                  if (
                    this.willAnyPolicyBeRenewed(
                      policyResponse,
                      lastDateOfRenewal
                    )
                  ) {
                    this.customerBannerService.setCustomerBannerData(
                      customerBannerData
                    );
                  }
                } else {
                  this.customerBannerService.setCustomerBannerData(
                    customerBannerData
                  );
                }
              } else {
                this.checkPaperlessBannerAndPopup(policyResponse);
              }
            },
            () => {
              this.checkPaperlessBannerAndPopup(policyResponse);
            }
          );
      } else {
        this.checkPaperlessBannerAndPopup(policyResponse);
      }
    } else {
      this.checkPaperlessBannerAndPopup(policyResponse);
    }
  }
  private detectStateCode(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }
  willAnyPolicyBeRenewed(policiesData, renewalMonthLastDate) {
    const policiesToBeRenewed = policiesData.filter(
      (policy) =>
        policy.policyStatus === 'ACTIVE' &&
        this.isRenewalInRange(renewalMonthLastDate, policy.expDate)
    );
    return !!policiesToBeRenewed.length;
  }
  isRenewalInRange(lastDate, policyExpDate) {
    const renewalYear = new Date(lastDate).getFullYear();
    const renewalMonth = new Date(lastDate).getMonth();
    const renewalMonthFirstDate = new Date();
    renewalMonthFirstDate.setDate(1);
    renewalMonthFirstDate.setMonth(renewalMonth);
    renewalMonthFirstDate.setFullYear(renewalYear);
    return (
      renewalMonthFirstDate <= new Date(policyExpDate) &&
      new Date(lastDate) >= new Date(policyExpDate)
    );
  }
  public ngOnInit() {
    this.isNative();
    this.loading = true
    this.loginCount = localStorage.getItem('loginCount');
    let allPoliciesList;

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      if (response) {
        this.isPaperless = response.paper;
        this.isAutoPay = response.eft;
        this.isPaymentus = response.pu;
        this.isACH = response.ach;
        this.payBill = response.pb;
        this.isCCDC = response.isCCDC;
        this.showOpenBayOnRunDate = response.openBay;
      }
    });

    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        this.checkCustomerBannerOrPaperlessEligibility(policyResponse);
        _.forEach(policyResponse, (policy) => {
          const { effDate } = policy;
          if (effDate) {
            const autoPay = this.policyDetailsService.getDayDifference(effDate);
            policy = { ...policy, autoPay };
          }

          if (this.isActivePolicy(policy)) {
            this.activePolicyArray.push(policy)
          } else {
            this.inactivePolicyArray.push(policy)
          }
          this.calculateAmounts(policy)
          this.allPolicies.push(policy)
        });

        policyResponse.forEach((policy) => {
          this.showBillingMessage =
            this.showBillingMessage || !policy.hasAffinityGroup;
        });

      }
    });
    this.clientCredentialsService.getToken().subscribe((token) => {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      user.access_token = token;
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.policyDataService.$policyDetails.subscribe((policyList) => {
        if (policyList && policyList.length) {
          this.policies = policyList;
          allPoliciesList = policyList;
          if (!this.isAcmic) {
            this.showLoyaltyBannerOnRouteChange(this.router, allPoliciesList);
          }
        }
      });
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if (!this.isAcmic) {
            this.showLoyaltyBannerOnRouteChange(event, allPoliciesList);
          }
        })
    })
    this.getRenawalLivoPolicy();
    this.getExpiringLivoPolicies();
    this.policyDataService.setPolicyNumber('');
    localStorage.removeItem('loginCount');
  }

  isActivePolicy(policy: any): boolean {
    return ((policy.billingDetails && policy.billingDetails[0] &&
      policy.billingDetails[0].outstandingbalance > 0 && policy.policyStatus === 'CANCELLED')
      || policy.policyStatus == 'FUTURE' || policy.policyStatus == 'ACTIVE'
    );
  }

  getRenawalLivoPolicy() {
    this.policyDataService.$renewalPolicy.subscribe(
      (renewalPolicyList: any) => {
        if (renewalPolicyList && renewalPolicyList.length > 0) {
          this.expiringPolicyArray = renewalPolicyList;
          this.activePolicyArray = _.filter(
            this.activePolicyArray,
            (policy) => {
              return renewalPolicyList.some(
                (x) => policy.policynumber.policyNumber != x.livoPolicy
              );
            }
          );
        }
      }
    );
  }

  getExpiringLivoPolicies() {
    this.policyDataService.$expiringLivoPolicies.subscribe(
      (expiringPolicyList: any) => {
        this.expiringLivoPolicyList = [];
        if (expiringPolicyList && expiringPolicyList.length) {
          this.expiringLivoPolicyList = expiringPolicyList;
        }
      }
    );
    this.loading = false;
  }

  calculateAmounts(policy) {
    policy.calculatedBalanceDetails = {
      outstandingBalance: 0,
      priorTermBalance: 0,
      currentMinAmtDue: 0,
      paymentDate: "",
    }
    if (policy && policy.billingDetails?.[0]) {
      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        policy.calculatedBalanceDetails.outstandingBalance =
          policy.billingDetails[0].outstandingbalance + policy.priorYearBalance.theAmount;
      } else {
        policy.calculatedBalanceDetails.outstandingBalance = policy.billingDetails[0].outstandingbalance;
      }

      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        if (
          policy.policyCancellationReason &&
          (policy.policyCancellationReason.toLowerCase() ==
            Constants.CANCILLATION_REASON_NON_PAYMENT ||
            policy.policyCancellationReason.toLowerCase() ==
            Constants.CANCILLATION_REASON_FPD_FAILURE) &&
          policy.policyStatus != 'CANCELLED'
        ) {
          policy.calculatedBalanceDetails.currentMinAmtDue =
            policy.exitDelinquencyAmount.theAmount +
            policy.priorYearBalance.theAmount;
          policy.calculatedBalanceDetails.paymentDate = policy.policyCancellationEffectiveDate;
        } else {
          policy.calculatedBalanceDetails.currentMinAmtDue =
            policy.billingDetails[0].amountStillDue +
            policy.priorYearBalance.theAmount;
          policy.calculatedBalanceDetails.paymentDate = policy.billingDetails[0].paymentDueDate;
        }
      } else if (
        policy.policyCancellationReason &&
        (policy.policyCancellationReason.toLowerCase() ==
          Constants.CANCILLATION_REASON_NON_PAYMENT ||
          policy.policyCancellationReason.toLowerCase() ==
          Constants.CANCILLATION_REASON_FPD_FAILURE) &&
        policy.policyStatus != 'CANCELLED'
      ) {
        policy.calculatedBalanceDetails.currentMinAmtDue = policy.exitDelinquencyAmount.theAmount;
        policy.calculatedBalanceDetails.paymentDate = policy.policyCancellationEffectiveDate;
      } else {
        policy.calculatedBalanceDetails.currentMinAmtDue = policy.billingDetails[0].amountStillDue;
        policy.calculatedBalanceDetails.paymentDate = policy.billingDetails[0].paymentDueDate;
      }

      policy.calculatedBalanceDetails.priorTermBalance =
        policy.priorYearBalance && policy.priorYearBalance.theAmount
          ? policy.priorYearBalance.theAmount
          : 0;
    }

    const policyNumber = policy?.policynumber?.policyNumber;
    if (policyNumber) {
      this.outBalanceTooltipContentMap[policyNumber] = this.policyTooltipService.getOutstandingBalanceTooltip(policy);
    }
  }

  calculateOutstandingBalance(policy) {
    this.calculateAmounts(policy);

    if (policy.billingDetails?.[0] && policy.hasPriorYearBalance) {
      return (
        policy.billingDetails[0].outstandingbalance +
        policy.priorYearBalance.theAmount
      );
    } else {
      return policy.billingDetails?.[0]
        ? policy.billingDetails[0].outstandingbalance
        : 0;
    }
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }

  calculate(policy) {
    this.calculateAmounts(policy);
    return true;
  }

  expandBalances(name, rotate, policyNumber) {
    if (document.getElementById(name + policyNumber)) {
      if (
        !document
          .getElementById(name + policyNumber)
          .classList.contains(Constants.HIDE_AMOUNT_CLASS)
      ) {
        document
          .getElementById(name + policyNumber)
          .classList.add(Constants.HIDE_AMOUNT_CLASS);
      } else {
        document
          .getElementById(name + policyNumber)
          .classList.remove(Constants.HIDE_AMOUNT_CLASS);
      }

      if (
        document
          .getElementById(rotate + policyNumber)
          .classList.contains(Constants.EXPANDED_ARROW_CLASS)
      ) {
        document
          .getElementById(rotate + policyNumber)
          .classList.replace(Constants.EXPANDED_ARROW_CLASS, Constants.COLLAPSED_ARROW_CLASS);
      } else {
        document
          .getElementById(rotate + policyNumber)
          .classList.replace(Constants.COLLAPSED_ARROW_CLASS, Constants.EXPANDED_ARROW_CLASS);
      }
    }
  }

  isPolicyEligibleForLoyaltyBanner(policy) {
    if (policy) {
      return (policy.policyType === 'AUTO' && policy.policySubType !== 'MAIP') ||
        (policy.policyType === 'HOME' && policy.policySubType !== 'FAIR') ||
        (policy.policynumber.policyNumber.length === 6 && policy.policyType === 'AUTO')
    }
    return false;
  }

  private isAtleastOnePolicyElgblForLoyaltyBanner(policyList: any[]) {
    let isLoyaltyBannerVisible = false;
    policyList?.forEach(policy => {
      if (!isLoyaltyBannerVisible) {
        isLoyaltyBannerVisible = this.isPolicyEligibleForLoyaltyBanner(policy);
      }
    });
    return isLoyaltyBannerVisible;
  }

  showLoyaltyBannerOnRouteChange(eventOrRoute, allPoliciesList) {
    if (eventOrRoute?.url === Constants.MY_INSURANCE ||
      (eventOrRoute?.url === '/billing-new' || eventOrRoute.url === '/billing-new/billing-landing')) {
      this.showLoyaltyBanner = this.isAtleastOnePolicyElgblForLoyaltyBanner(allPoliciesList);
    } else if ((eventOrRoute?.url?.startsWith(Constants.MY_INSURANCE) && (eventOrRoute?.url?.endsWith('/details') || eventOrRoute?.url?.endsWith('/coverages')) ||
      (eventOrRoute?.url?.startsWith('/billing-new/')))) {
      const policyIdFromUrl = eventOrRoute.url.split('/')[2];
      const policyObj = allPoliciesList.find(policy => policyIdFromUrl === policy?.policynumber?.policyNumber);
      this.showLoyaltyBanner = this.isPolicyEligibleForLoyaltyBanner(policyObj);
    } else {
      this.showLoyaltyBanner = false;
    }
  }
}